module.exports = __webpack_public_path__ + "img/140.ab02f6ca.jpg";